// SSO configuration read from build-time env (generated by `make gen-env`).
// VUE_APP_SSO_PROVIDERS is a JSON array of { name, label } where `name` is the
// Cognito identity-provider name (e.g. "Google", "EntraID") and `label` is the
// button text. The login screen renders one button per entry.
export function ssoProviders() {
  try {
    const raw = process.env.VUE_APP_SSO_PROVIDERS || "[]";
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

export const awsRegion = process.env.VUE_APP_AWS_REGION || "eu-west-3";
